const access = (dis, store, client) => {
  function load(entityType, entityId) {
    return client
      .get(`/api/access/${entityType}/${entityId}`)
      .then((response) => {
        const { description, ...rest } = response.data
        dis({ type: 'access/setDescription', payload: description })
        dis({ type: 'access/updateRules', payload: rest })
        dis({ type: 'access/setLoading', payload: false })
        return response.data
      })
      .catch((error) => {
        dis({ type: 'access/setLoading', payload: false })
        dis({ type: 'access/setError', payload: 'Failed to load access settings' })
      })
  }

  function persist(entityType, entityId) {
    let rules = store.getState().access.rules
    if ('description' in rules) {
      const { description, ...rest } = rules;
      rules = rest;
    }

    return client
      .post(`/api/access/${entityType}/${entityId}`, rules)
      .then((response) => {
        updateRules(response.data)
        dis({ type: 'access/setDirty', payload: false })
        return response.data
      })
      .catch((error) => {
        dis({ type: 'access/setError', payload: 'Failed to save access settings' })
      })
  }

  function updateRules(payload) {
    dis({ type: 'access/setDirty', payload: true })
    dis({ type: 'access/updateRules', payload })
  }

  function updateRootOrgRule(grantType) {
    dis({ type: 'access/setDirty', payload: true })
    dis({ type: 'access/updateRootOrgRule', payload: grantType })
  }

  function updateSubOrgRule(externalType, enabled, accessKind) {
    if (enabled) {
      dis({ type: 'access/upsertSubOrgRule', payload: { externalType, accessKind } })
    } else {
      dis({ type: 'access/removeSubOrgRule', payload: externalType })
    }
    dis({ type: 'access/setDirty', payload: true })
  }

  function removeSubOrgRules() {
    dis({ type: 'access/setDirty', payload: true })
    dis({ type: 'access/removeSubOrgRules', payload: null })
  }

  function upsertSpecificOrgRule(orgId, accessKind) {
    var pattern = /^[0-9]*$/;
    if (!pattern.test(orgId)) {
      console.error('Invalid organisation ID:', orgId);
      return;
    }
    let rules = store.getState().access.rules
    const otherRules = rules.organisations.filter((orgRule) => orgRule.id !== orgId)
    const newRule = {
      id: orgId,
      grantToSuborganisations: 'none',
      accessKind: accessKind,
    }
    updateRules({
      ...rules,
      organisations: [...otherRules, newRule],
    })
  }

  function removeSpecificOrgRule(orgId) {
    let rules = store.getState().access.rules
    const otherOrgRules = rules.organisations.filter((orgRule) => orgRule.id !== orgId)
    updateRules({
      ...rules,
      organisations: otherOrgRules,
    })
  }

  function addSpecificOrgRule(orgId) {
    let rules = store.getState().access.rules
    if (rules.organisations.some((orgRule) => orgRule.id === orgId)) {
      console.warn(`Organisation rule for ${orgId} already exists.`);
      return;
    }
    upsertSpecificOrgRule(orgId, 'view')
  }

  function fetchOrganisationNames(orgIds) {
    const map = {...store.getState().access?.organisationNames || {}}
    client.get('/api/organisations?' + orgIds.map(id => 'ids[]=' + id).join('&'))
      .then((r) => r.data).then((data) => {
        data.forEach(org => { map[org.value] = org.label })
        dis({ type: 'access/setOrganisationNames', payload: map })
    })
  }

  return {
    load,
    persist,
    updateRules,
    updateRootOrgRule,
    updateSubOrgRule,
    removeSubOrgRules,
    upsertSpecificOrgRule,
    removeSpecificOrgRule,
    addSpecificOrgRule,
    fetchOrganisationNames
  }
}

export default access
